<div class="modal">
	<div class="modal-content">
		<div class="modal-header">
			<h2 i18n="@@signup.signup">Sign Up</h2>
			<span class="close" (click)="closeSignup()">&times;</span>
		</div>
		<div class="modal-body">
			<form [formGroup]="signupForm" (ngSubmit)="onSubmit()">				
				<div class="d-flex flex-wrap">
					<fieldset class="half" [ngClass]="{'has-error': (isSubmitted || signupForm.get('first_name')?.dirty) && signupForm.get('first_name')?.errors}">
						<label for="first_name" i18n="@@singup.first_name">First Name</label>
						<input formControlName="first_name" type="first_name" id="first_name" required />
						<span class="field-error" *ngIf="signupForm.get('first_name')?.errors?.required" i18n="@@error.required.first_name">First Name is required</span>
						<span class="field-error" *ngIf="signupForm.get('first_name')?.errors?.minLength" i18n="@@error.required.minLength">Minimum lentgh is 3</span>
					</fieldset>

					<fieldset class="half" [ngClass]="{'has-error': (isSubmitted || signupForm.get('last_name')?.dirty) && signupForm.get('last_name')?.errors}">
						<label for="last_name" i18n="@@singup.last_name">Last Name</label>
						<input formControlName="last_name" type="last_name" id="last_name" required />
						<span class="field-error" *ngIf="signupForm.get('last_name')?.errors?.required" i18n="@@error.required.last_name">Last Name is required</span>
						<span class="field-error" *ngIf="signupForm.get('last_name')?.errors?.minLength" i18n="@@error.required.minLength">Minimum lentgh is 3</span>
					</fieldset>
				</div>
				
				<div class="d-flex flex-wrap">
					<fieldset class="half" [ngClass]="{'has-error': (isSubmitted || signupForm.get('phone')?.dirty) && signupForm.get('phone')?.errors}">
						<div class="form_phone">
							<label for="phone" i18n="@@signup.enter_your_phone_number">Enter Your Phone Number</label>
							<div class="tel-input-group">
								<input formControlName="phone" type="number" id="phone" required />
							</div>
							<span class="field-error" *ngIf="signupForm.get('phone')?.errors?.required" i18n="@@error.required">Phone number is required</span>
							<span class="field-error" *ngIf="!signupForm.get('phone')?.errors?.required && !signupForm.get('phone')?.errors?.phoneTaken" i18n="@@error.invalid_number">Invalid phone number</span>
							<span class="field-error" *ngIf="signupForm.get('phone')?.errors?.phoneTaken" i18n="@@error.invalid_number">Phone is already taken</span>
							<span class="field-error" *ngIf="signupForm.get('phone')?.errors?.serverError">{{ signupForm.get('phone')?.errors?.serverError }}</span>
						</div>
					</fieldset>
					
					<fieldset class="half" [ngClass]="{'has-error': (isSubmitted || signupForm.get('dob')?.dirty) && signupForm.get('dob')?.errors}">
						<label for="dob" i18n="@@singup.dob">Date of Birth</label>
						<input formControlName="dob" type="date" id="dob" autocomplete="new-dob" required (click)="openDatePicker($event)">
						<span class="field-error" *ngIf="signupForm.get('dob')?.errors?.required" i18n="@@error.required.dob">Date of birth is required</span>
					</fieldset>
				</div>

				<div class="d-flex flex-column">
					<fieldset class="" [ngClass]="{'has-error': (isSubmitted || signupForm.get('email')?.dirty) && signupForm.get('email')?.errors}">
						<label for="email" i18n="@@singup.email">Email</label>
						<input formControlName="email" type="email" id="email" autocomplete="new-email" required />
						<span class="field-error" *ngIf="signupForm.get('email')?.errors?.required" i18n="@@error.required.email">Email is required</span>
						<span class="field-error" *ngIf="signupForm.get('email')?.errors?.email" i18n="@@error.valid_email">Please enter valid email address</span>
						<span class="field-error" *ngIf="signupForm.get('email')?.errors?.emailTaken" i18n="@@error.required">Email is already taken</span>
						<span class="field-error" *ngIf="signupForm.get('email')?.errors?.serverError">{{ signupForm.get('email')?.errors?.serverError }}</span>
					</fieldset>

					<fieldset class="" [ngClass]="{'has-error': (isSubmitted || signupForm.get('password')?.dirty) && signupForm.get('password')?.errors}">
						<label for="password" i18n="@@singup.password">Password</label>
						<input formControlName="password" type="password" id="password" autocomplete="new-password" required />
						<span class="field-error" *ngIf="signupForm.get('password')?.errors?.required" i18n="@@error.required.password">Password is required</span>
						<span class="field-error" *ngIf="signupForm.get('password')?.errors?.minlength" i18n="@@error.confirm_password_same_new_password">Password must be at least 6 characters long</span>
					</fieldset>

					<fieldset class="" [ngClass]="{'has-error': (isSubmitted || signupForm.get('confirm_password')?.dirty) && signupForm.get('confirm_password')?.errors}">
						<label for="confirmPassword" i18n="@@singup.confirm_password">Confirm Password</label>
						<input formControlName="passwordConfirm" type="password" id="confirmPassword" required />
						<span class="field-error" *ngIf="signupForm.get('passwordConfirm')?.errors?.required" i18n="@@error.required.confirm_password">Confirm password is required</span>
						<span class="field-error" *ngIf="signupForm.get('passwordConfirm')?.errors?.mismatch" i18n="@@error.confirm_password_same_new_password">Password and confirmation password must be the same</span>
					</fieldset>
				</div>

				<div class="form-actions">
					<button type="submit" class="signUpBtn btn btn-primary" i18n="@@signup.signup">Sign Up</button>
				</div>
			</form>

			<div class="anotherVarContainer pt-4">
				<div class="line"></div>
				<span i18n="@@signup.already_have_an_account">Already have an account?</span>
				<div class="line"></div>
			</div>

			<a class="logInBtn" (click)="openSignInModal()" i18n="@@signup.log_in">Log In</a>
		</div>
	</div>
</div>